import React, { useMemo } from 'react'
import { Typography } from '@material-ui/core'
import { AccountAnalysisStatus } from '@mutual-services/account-types'

export type DocumentationStatusDescriptionProps = {
  status: AccountAnalysisStatus
}

export const DocumentationStatusDescription: React.FC<DocumentationStatusDescriptionProps> = (props) => {
  const { status } = props

  const description = useMemo(() => {
    if (status === AccountAnalysisStatus.ANALYST_QUEUE || status === AccountAnalysisStatus.INITIAL_ANALYSIS) {
      return (
        <>
          <Typography variant='airbnbBody1'>
            <b>Seja bem vindo(a) ao Mutual Crédito para Empresas! </b>
            Recebemos sua solicitação de crédito e agora nossa equipe está analisando os dados informados no seu cadastro e o valor solicitado. Este processo leva <b>até um dia útil </b>.
            E não se preocupe, você será informado do resultado da análise pelo e-mail cadastrado na sua solicitação.
          </Typography>
        </>
      )
    }
    if (status === AccountAnalysisStatus.DENIED || status === AccountAnalysisStatus.DENIED_POST_ANALYSIS) {
      return <Typography variant='airbnbBody1'>Infelizmente, não conseguimos encaixar a sua empresa na nossa linha de crédito para pessoa jurídica e liberar o limite de crédito solicitado. Esperamos estarmos juntos em um próximo momento. Caso tenha alguma dúvida sobre o processo de análise, estamos à disposição.</Typography>
    }
    if (status === AccountAnalysisStatus.WAITING_FOR_ANALYSIS || status === AccountAnalysisStatus.UNDER_ANALYSIS) {
      return (
        <>
          <Typography variant='airbnbBody1'>
            <b>Parabéns, você finalizou a etapa de documentação! </b>
            A nossa equipe agora vai avaliar os documentos enviados para continuar sua solicitação.
            Este processo pode levar <b>até dois dias úteis. </b>
            Não se preocupe, você será notificado por email quando concluirmos a validação dos documentos.
          </Typography>
        </>
      )
    }
    if (status === AccountAnalysisStatus.APPROVED) {
      return (
        <>
          <Typography variant='airbnbBody1'>
            Nosso time de crédito analisou seu pedido de empréstimo e validou sua documentação com sucesso! Entraremos em contato através do email
            <b> empresas@mutual.club </b>
            para informar as condições do crédito e os procedimentos para a liberação do recurso.
          </Typography>
        </>
      )
    }

    return (
      <Typography variant='airbnbBody1'>
        <b>Parabéns, você finalizou a etapa de documentação! </b>
        A nossa equipe agora vai avaliar os documentos enviados para continuar sua solicitação.
        Este processo pode levar até <b>dois dias úteis. </b>
        Não se preocupe, você será notificado por email quando concluirmos a validação dos documentos.
      </Typography>
    )
  }, [])

  return (
    <>
      {description}
    </>
  )
}
